import { reactive, ref } from 'vue'
import { useItemSearchApi } from './useItemSearchApi.js'

export const useItemSearchOptions = () => {
  const { fetchCategories, fetchScenes, fetchReceivingKinds } =
    useItemSearchApi()
  const filterOptions = reactive({
    categories: [],
    scenes: [],
    receivingKinds: []
  })
  const isLoading = ref(false)
  const error = ref(null)

  const loadOptions = async () => {
    isLoading.value = true
    error.value = null
    const loaders = [
      ['categories', fetchCategories],
      ['scenes', fetchScenes],
      ['receivingKinds', fetchReceivingKinds]
    ]

    try {
      for (const [key, load] of loaders) {
        try {
          filterOptions[key] = await load()
        } catch (cause) {
          error.value = cause
        }
      }
    } finally {
      isLoading.value = false
    }
  }

  return {
    filterOptions,
    isLoading,
    error,
    loadOptions
  }
}
